module.exports = __webpack_public_path__ + "img/scarlet devil mansion.0d989079.png";